import Auth from './auth/reducer';
import App from './app/reducer';
import SocialPage from './socialPage/reducers';
import Media from './media/reducer';
import PageMenu from './sidebarPageMenu/reducers';
import PageBody from './pageBody/reducers';
import Campaign from './campaign/reducer';
// import WifiMethod from './wifiMethod/reducer';
import Device from './device/reducers';
import WifiCampaign from './wifiCampaign/reducer';
import GuestCustomProfile from './guestCustomProfile/reducer';
import SaleLead from './saleLead/reducer';
import BeeTemplate from './beeTemplate/reducer';
import Zalo from './zalo/reducer';
import ZaloCampaign from './zaloCampaign/reducer';
import Task from './task/reducer';
import Gift from './gift/reducer';
import User from './user/reducer';
import {
  scopesReducer as Scopes,
  roleTemplatesReducer as RoleTemplates,
  pageRolesReducer as PageRoles,
  pageMembershipsReducer as PageMemberships,
  apiKeysReducer as ApiKeys
} from './rbac';

export default {
  Auth,
  App,
  SocialPage,
  PageMenu,
  Media,
  PageBody,
  Campaign,
  Device,
  WifiCampaign,
  GuestCustomProfile,
  SaleLead,
  BeeTemplate,
  Zalo,
  ZaloCampaign,
  Task,
  Gift,
  User,
  Scopes,
  RoleTemplates,
  PageRoles,
  PageMemberships,
  ApiKeys,
};
